'use strict'

let definition=require('../../definition/labels/english.js').english;
let quality=require('../../quality/labels/english.js').english;
let plan=require('../../plan/labels/english.js').english;
let businessCase=require('../../businessCase/labels/english.js').english;
let org=require('../../organization/labels/english.js').english;

export let english={
  menu: {
    reportActions: "Report Actions",
    viewFullScreen: "View full screen",
    tableView: "Show table view",
    reportView: "Show report view",
    viewPDF: "View PDF",
    viewWord: "Download as Word (docx)",
    viewSlideMode: "View slide mode",
    createDraft: "Create draft",
    updateDraft: "Update draft",
    approve: "Approve",
    documentArchive: "Document archive",
    current: "Current",
    draft: "draft",
    briefDetailsIsFollowedUpInPID: "No changes will be reflected in this Brief, as a Project Initiation Document is created."
  },
  brief: {
    title: "Project Brief",
    messagePreview: "Preview",
    messageDraft: "Draft",
    frontPage: "Front Page"
  },
  definition: {
    title: "Definition",
    background: {
      title: definition.background.title
    },
    objectives: {
      title: definition.objectives.title,
      aspects: definition.aspects,
      columns: definition.objectives.fields.objectivesSummary.columns
    },
    scope: {
      title: definition.scope.title,
      outcomes: definition.scope.fields.outcomes,
      excluded: definition.scope.fields.scopeExclusions
    },
    constraints: {
      title: definition.constraints.fields.constraints.title
    },
    assumptions: {
      title: definition.constraints.fields.assumptions.title
    },
    stakeholders: {
      title: definition.stakeholders.fields.stakeholderDescription.title
    },
    interfaces: {
      title: definition.stakeholders.fields.interfaces.title
    }
  },
  businessCase: {
    title: "Business Case",
    executiveSummary: businessCase.summary.fields.executiveSummary.title,
    reasons: businessCase.strategy.fields.reasons.title,
    doNothing: businessCase.options.fields.doNothing.title,
    doMinimal: businessCase.options.fields.doMinimal.title,
    doSomething: businessCase.options.fields.doSomething.title,
    benefits: {
      title: businessCase.benefits.fields.benefits.title,
      columns: businessCase.benefits.fields.benefits.columns
    },
    projectPlanSummary: businessCase.returnOnInvestment.fields.projectPlanSummary.title,
    investmentAppraisal: businessCase.returnOnInvestment.fields.investmentAppraisal.title,
    risks: businessCase.returnOnInvestment.fields.risks.title
  },
  projectProductDescription: {
    title: "Project Product Description",
    noOutputs: "No outputs defined.",
    columns: quality.projectProductDescription.fields.scopeDetails.columns
  },
  approach: {
    title: "Project Approach",
    methods: plan.planApproach.fields.methods.title,
    resources: plan.planApproach.fields.resources.title,
    technology: plan.planApproach.fields.technology.title,
    rollOut: plan.planApproach.fields.rollOut.title,
    other: plan.planApproach.fields.other.title
  },
  organization: {
    title: "Organization",
    columns: {
      name: "Name",
      role: "Role",
      description: "Description"
    },
    executive: org.roles.project.executive,
    seniorUser: org.roles.project.seniorUser,
    seniorSupplier: org.roles.project.seniorSupplier,
    businessAssurance: org.roles.project.businessAssurance,
    projectManager: org.roles.project.projectManager,
    teamManager: org.roles.project.teamManager,
    projectSupport: org.roles.project.projectSupport,
    changeAuthority: org.roles.project.changeAuthority,
    stakeholder: org.roles.project.stakeholder,
    userAssurance: org.roles.project.userAssurance,
    supplierAssurance: org.roles.project.supplierAssurance,
    teamMember: org.roles.project.teamMember
  },
  approval: {
    fields: {
      approvedBy: {
        title: "Approved by",
        description: "Describe by whom and when the document was approved"
      }
    },
    cancel: "Cancel",
    approve: "Approve Project Brief",
    thisFieldIsRequired: "This field is required."
  }
};



// WEBPACK FOOTER //
// ./views/brief/labels/english.js